import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api, formatApiError } from "@/lib/api";

export function DeleteButton({ path, name, what, redirect, testId }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const confirm = async () => {
    try {
      await api.delete(path);
      toast.success(`${what} deleted`);
      navigate(redirect);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid={testId} className="inline-flex items-center gap-2 rounded-full border border-lasso-line bg-white px-4 py-2 text-sm font-semibold text-rose-600 transition-colors hover:border-rose-400">
        <Trash2 className="h-4 w-4" /> Delete
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid={`${testId}-dialog`}>
          <AlertDialogHeader>
            <AlertDialogTitle>Permanently delete “{name}”?</AlertDialogTitle>
            <AlertDialogDescription>
              This removes the {what.toLowerCase()} and all related data (assignments, progress, acknowledgments{what === "Course" ? ", quiz attempts and certificates" : ", version history"}). This cannot be undone. Consider archiving instead.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={confirm} className="bg-rose-600 hover:bg-rose-700" data-testid={`${testId}-confirm`}>Delete permanently</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
